import { Bound } from "lib/@components/binding/Bound"
import { AmendsBoundary } from "authoring/routes/project/amends/components/amends-boundary"
import { useAmendsValue } from "./hooks/use-amends-value"
import { useScheduleEditorActions } from "./hooks/use-schedule-editor-actions"
import { useScheduleEditorDraftTokens } from "./hooks/use-schedule-editor-draft-tokens"

/** Reads amends/actions from the editor session — avoids prop drilling from ScheduleEditor. */
export function ScheduleEditorAmendsBoundary({ children }) {
    const { amends } = useAmendsValue()
    const { saveAmend, deleteAmend } = useScheduleEditorActions()
    const { macroMap } = useScheduleEditorDraftTokens()

    return (
        <Bound macroMap={macroMap}>
            <AmendsBoundary amends={amends} onSaveAmend={saveAmend} onDeleteAmend={deleteAmend}>
                {children}
            </AmendsBoundary>
        </Bound>
    )
}
